<template>
<div class="main-in">
    <div class="container" v-cloak>
        <div is='titlebox' :nav='JSON.parse(nav)' ></div>
        <div class="content">
            <!-- <div class="left-corner f-row-l">
                <div class="bg-title1 f-row-c bbact">{{title}}</div>
            </div> -->
            <div class="words min-h" v-if='this.type!=12&&this.type!=13'>
                <strong v-if='info.title'>{{info.title}}</strong>
                <ul>
                    <li v-if='info.source'>来源：{{info.source}}</li>
                    <li v-if='info.author'>作者：{{info.author}}</li>
                    <li v-if='info.createTime'>发布时间：{{info.createTime}}</li>
                </ul>
                <div class="words2 pt-4">
                    <div v-html="$util.regImg(info.content)" v-if='info.content'></div>
                    <div v-html="$util.regImg(info.hypertext)"  v-if='info.hypertext'></div>
                </div>
                <div v-if='fileList.length>0'>
                    <div v-for='(item,innd) in fileList' :key='ind' v-if='innd==0'>
                        <videoBox :index='ind' :itemPlayTip='item.playTip' :file='item.file' @onChangeVideo='onChangeVideo'></videoBox>
                    </div>
                </div>
            </div>
            <div v-else class="min-h">
                <strong v-if='info.title'>{{info.memberName}}</strong>
                <div class="words2 pt-4">
                    <div class="f-row-c">
                        <img class="headbox" v-if='info.memberImg' :src='$fileAccessHttpUrl(info.memberImg)'/>
                    </div>
                    <div class="f-row-c mt-1 title">{{info.memberName}}</div>
                    <div class="" v-if='info.memberIntroduce'>
                        <div v-html="$util.regImg(info.memberIntroduce)"></div>
                    </div>
                    
                </div>
            </div>
            <!-- {{JSON.stringify(info)}} -->
            <div v-if='info.file' class="downbox">
                <div v-if='type!=32'>
                    <span class="downicon pinter" v-for='(item,ind) in info.file.split(",")' :key='ind' :title="item" @click="openUrl($fileAccessHttpUrl(item))">
                    附件下载
                    </span>
                </div>
                
            </div>
        </div>
    </div>
</div>
</template>
<script>
export default {
    computed:{
        nav:function(){
            var tier=2;
            var type=this.$route.query.type
            if((type>=14)&&(type<=32)&&type!=24&&type!=31){ 
                tier=3
            }
            if ((type >= 36) && (type <= 48)) {
                tier = 3
            }
            var arr=this.$util.getTopNav(this.title, this.$route.query.type,this.$route.query.isPrivate,tier)
            console.log('arr',arr)
            return JSON.stringify(arr)
        },
    },
    data() {
        return {
            type:this.$route.query.type,
            title:this.$route.query.title,
            msgType:'',
            info:{},
            fileList:[]
        };
    },
    created(){
        
        this.typeIs()
    },
    methods:{
        onChangeVideo(e){
            for(var i=0;i<this.fileList.length;i++){ 
                if(i==e.index){ 
                this.$set(this.fileList[e.index],'playTip',e.playTip)
                }else{ 
                this.$set(this.fileList[e.index],'playTip',!e.playTip)
                }
            }
            
        },
        openUrl(url){
            window.open(url)
        },
        typeIs(){
            this.fileList=[]//清楚视频列表
            this.title=this.$util.getDetailTitle(this.type)
            this.type=this.type*1
            if(this.type==6||this.type==7){ //'活动详情' '图集详情'
                this.getInfo(this.$route.query.id)
            }else if(this.type==24){ //'维权详情'
                this.getRights(this.$route.query.id)
            }else if(this.type==12||this.type==13){ //优秀人员
                this.getPersonInfo(this.$route.query.id)
            }else if(28<=this.type&&this.type<=30){//志愿者项目接口
                this.getZYinfo(this.$route.query.id)
            }else if(this.type==15){
              this.getActivity(this.$route.query.id)
            }else{ //资讯类 1~5 8~27 &&!12&&!13&&!15&&!24
                this.getDetail(this.$route.query.id)
            }
           
        },
      getActivity(id){
        this.$get('/web/home/queryItemById?id='+id).then(res=>{
          if(res.success){
            this.info=res.result
          }
        })
      },
        getZYinfo(id){//志愿者接口
            this.$axios.get(this.$apiUrlZY+`api/external/queryRootById?id=${id}`).then(res=>{ 
                this.info=res.result
            })
        },
        getPersonInfo(id){//this.type==12||this.type==13
             this.$get('/web/member/queryById?id='+id).then(res=>{
                if(res.success){
                    this.info=res.result
                }
            })
        },
        getDetail(id ){
            this.$get('/web/information/queryById?id='+id).then(res=>{ 
                if(res.success){ 
                    this.info=res.result
                    if(this.type==32){ //试听课件
                        this.fileList=[]
                        if(this.info.file){ 
                            var list=this.info.file.split(",")
                            list.forEach((k)=>{ 
                                this.fileList.push({ 
                                    file:k,
                                    playTip:false,
                                })
                            })
                        }
                    }
                }
            })
        },
        getInfo(id ){
            this.$get('/web/home/getLasDetails?id='+id).then(res=>{ 
                if(res.success){ 
                    this.info=res.result
                    this.info.title=res.result.pictureTitle
                    this.info.content=res.result.pictureContent
                }
            })
        },
        getRights(id){
            this.$get('/web/doorProtect/queryById?id='+id).then(res=>{ 
                if(res.success){ 
                    this.info=res.result
                }
            })
        }
    },
    mounted(){
        
    },
}
</script>
<style lang="scss" scoped>
.content {
    position: relative;
    background-color: #fff;
    padding: 0px 50px;
    min-height: 480px;
    .left-corner {
        line-height: 5px;
        border-bottom: #d6dde6 1px solid;
    }

    .words{
        font-size: 16px;
        line-height: 38px;
        text-align: center;
        font-family: Microsoft YaHei;
        margin-top: 42px;
        padding-bottom: 200px;
        strong{
            width: 100%;
            font-size: 28px;
            color: #333333;
            line-height: 40px;
            font-weight: 400;
        }
        ul{
            width:  100%;
            text-align: center;
            margin-left: -15px;
             li{
                list-style: none;
                display: inline;
                font-weight: 400;
                color: #666666;
                font-family: Microsoft YaHei;
                padding: 20px;
            }
        }
        .words2{
            width: 100%;
            text-align: left;
            font-weight: 400;
            font-family: Microsoft YaHei;
            color: #333333;
            line-height: 38px;
            padding:0px 10px 10px;
        }
    }
}
.headbox{
    width: 200px;
}
.title{
    font-size: 28px;
    padding-bottom: 20px;
}
.downbox{
    margin: 30px 50px 50px;
    font-size: 16px;
    color: #E61F26;
    .downicon{
    position: relative;
    display: inline-block;
    padding-left: 22px;
    padding-bottom: 20px;
    margin-right: 30px;
  }
  .downicon::before{ 
    content: '';
    width: 18px;
    height: 20px;
    position: absolute;
    left: 0px;
    background: url('../../assets/img/index/tuanzhang.png') no-repeat center/100% auto;
  }
}
</style>
